import { render } from "./Faq.vue?vue&type=template&id=9a9b3d8a&scoped=true"
import script from "./Faq.vue?vue&type=script&lang=js"
export * from "./Faq.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-9a9b3d8a"

export default script